import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withModifiers as _withModifiers, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h4", { style: {"color":"inherit"} }, "Usuario inactivo", -1)
const _hoisted_2 = { class: "py-3 text-center" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("i", {
  style: {"font-size":"4rem"},
  class: /*#__PURE__*/_normalizeClass( 'fas fa-clock')
}, null, -1)
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = /*#__PURE__*/_createElementVNode("p", {
  class: "pt-4 px-4 text-modal",
  style: {"font-size":"1rem"}
}, " Se ha detectado que se encuentra inactivo ", -1)
const _hoisted_6 = {
  class: "pb-4 px-4 text-modal",
  style: {"font-size":"1rem"}
}
const _hoisted_7 = { class: "d-flex w-100 p-3" }
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" Mantener sesión ")

import Modal from "@/components/Modal.vue";
import { computed, onMounted, ref } from "vue";
import { AuthModule } from "@/store/modules/Auth"

// Computed

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const show = computed(() => AuthModule.inactive);

// Ref
const timer = ref(60); // Cantidad de segundos ha esperar para cerrar la sesión automaticamente

// Methods
const handleTimer = setInterval(() => {
    if(timer.value === 0) {
        clearInterval(handleTimer)
		AuthModule.setActivity(false);
        AuthModule.logout()
    }
    else
        timer.value--
}, 1000)

function handleClose() {
    clearInterval(handleTimer)
	AuthModule.setActivity(false);
}

onMounted(() => {
    handleTimer;
})


return (_ctx: any,_cache: any) => {
  const _component_base_button = _resolveComponent("base-button")!

  return (_openBlock(), _createBlock(Modal, {
    show: _unref(show),
    onClose: handleClose,
    "modal-classes": `modal-danger`,
    "body-classes": "py-0",
    style: {"animation-duration":"0.3s"},
    "modal-content-classes": `bg-gradient-danger`
  }, {
    header: _withCtx(() => [
      _hoisted_1
    ]),
    footer: _withCtx(() => [
      _createElementVNode("div", _hoisted_7, [
        _createVNode(_component_base_button, {
          type: "secondary",
          "native-type": "submit",
          class: "ml-auto",
          onClickCapture: _withModifiers(handleClose, ["stop"])
        }, {
          default: _withCtx(() => [
            _hoisted_8
          ]),
          _: 1
        }, 8, ["onClickCapture"])
      ])
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("span", {
          class: _normalizeClass(["avatar avatar-sm rounded-circle mt-3", {
					'no-background': true,
				}]),
          style: {"color":"inherit"}
        }, _hoisted_4),
        _hoisted_5,
        _createElementVNode("p", _hoisted_6, " La sesión se cerrara automaticamente en " + _toDisplayString(timer.value) + " segundos ", 1)
      ])
    ]),
    _: 1
  }, 8, ["show"]))
}
}

})